import { render, staticRenderFns } from "./VueTypeaheadBootstrap.vue?vue&type=template&id=0b1d6a06&scoped=true&"
import script from "./VueTypeaheadBootstrap.vue?vue&type=script&lang=js&"
export * from "./VueTypeaheadBootstrap.vue?vue&type=script&lang=js&"
import style0 from "./VueTypeaheadBootstrap.vue?vue&type=style&index=0&id=0b1d6a06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1d6a06",
  null
  
)

export default component.exports